/* ============================================================
   Annie Loves Cakes — decorator application
   Loaded by layout/apply.liquid. Boots whenever the DOM is ready,
   so it survives being moved, inlined or loaded without defer.
   ============================================================ */
(function () {
  function boot() {
  /* ============================================================
     Live Formspree endpoint (Forms → Integration).
     File uploads require a paid Formspree plan.
     ============================================================ */
  const FORMSPREE_ENDPOINT = "https://formspree.io/f/xojgvokk";

  const form     = document.getElementById('form');
  form.action = FORMSPREE_ENDPOINT;
  form.method = 'POST';
  const steps    = [...document.querySelectorAll('.step')];
  const parts    = [...document.querySelectorAll('.part')];
  const roadmap  = document.getElementById('roadmap');
  const fill     = document.getElementById('fill');
  const barStep  = document.getElementById('barStep');
  const barCount = document.getElementById('barCount');
  const backBtn  = document.getElementById('back');
  const nextBtn  = document.getElementById('next');
  const footNote = document.getElementById('footNote');
  const scroller = document.getElementById('scroller');
  const done     = document.getElementById('done');
  const last     = steps.length - 1;
  let i = 0;

  /* build the roadmap from the steps themselves */
  steps.forEach(s => {
    const li = document.createElement('li');
    li.textContent = s.dataset.title;
    roadmap.appendChild(li);
  });
  const rows = [...roadmap.children];

  function paint(){
    steps.forEach((s,n) => s.classList.toggle('on', n === i));
    rows.forEach((r,n) => {
      r.classList.toggle('now', n === i);
      r.classList.toggle('done', n < i);
    });
    parts.forEach((p,n) => p.classList.toggle('on', n < i));
    fill.style.width = ((i + 1) / (steps.length + 1) * 100) + '%';
    barStep.textContent = steps[i].dataset.title;
    barCount.textContent = (i + 1) + ' / ' + steps.length;
    backBtn.hidden = i === 0;
    nextBtn.textContent = i === last ? 'Send my application' : 'Continue →';
    footNote.textContent = i === last
      ? 'One last look, then send.'
      : 'Your details stay with Annie. Nothing is shared.';
    scroller.scrollTop = 0;
  }

  /* ---------- validation ---------- */
  function mark(el, bad){
    const box = el.closest('.field, fieldset');
    if (box) box.classList.toggle('bad', bad);
  }
  function firstInvalid(step){
    let bad = null;
    step.querySelectorAll('input, textarea, select').forEach(el => {
      if (el.type === 'hidden' || el.name === '_gotcha') return;
      if (el.closest('[hidden]')) return;
      const ok = el.checkValidity() && !(el.value && !el.value.trim() && el.required);
      mark(el, !ok);
      if (!ok && !bad) bad = el;
    });
    return bad;
  }
  function validate(n){
    const step = steps[n];
    let bad = firstInvalid(step);

    /* skills: at least one tick */
    if (step.querySelector('#skillsSet')){
      const any = step.querySelectorAll('input[name="Skills"]:checked').length > 0;
      step.querySelector('#skillsSet').classList.toggle('bad', !any);
      if (!any && !bad) bad = step.querySelector('input[name="Skills"]');
    }

    /* portfolio: 2–4 photos OR a link */
    if (step.querySelector('#photosField')){
      const files = photos.files.length;
      const link  = portfolio.value.trim();
      const photosOk = files >= 2 && files <= 4;
      const linkOk   = link !== '' && portfolio.checkValidity();
      const ok = photosOk || linkOk;
      if (files > 0 && !photosOk){
        photosErr.textContent = files < 2 ? 'Two photos minimum, please.' : 'Four photos maximum, please.';
        photosField.classList.add('bad'); linkField.classList.remove('bad');
        if (!bad) bad = photos;
      } else if (!ok){
        photosErr.textContent = 'Add 2–4 photos, or paste a portfolio link below.';
        photosField.classList.add('bad'); linkField.classList.add('bad');
        if (!bad) bad = photos;
      } else {
        photosField.classList.remove('bad'); linkField.classList.remove('bad');
      }
    }
    return bad;
  }

  function go(dir){
    if (dir > 0){
      const bad = validate(i);
      if (bad){
        const box = bad.closest('.field, fieldset');
        if (box && box.scrollIntoView) box.scrollIntoView({behavior:'smooth', block:'center'});
        if (bad.type !== 'file' && bad.type !== 'radio' && bad.type !== 'checkbox') bad.focus({preventScroll:true});
        return false;
      }
    }
    i = Math.min(last, Math.max(0, i + dir));
    paint();
    return true;
  }
  backBtn.addEventListener('click', () => go(-1));

  /* clear the error the moment they fix it */
  form.addEventListener('input', e => {
    const box = e.target.closest('.field, fieldset');
    if (box && box.classList.contains('bad') && e.target.checkValidity()) box.classList.remove('bad');
  });
  form.addEventListener('change', e => {
    if (e.target.name === 'Skills') skillsSet.classList.remove('bad');
  });

  /* ---------- conditional: Tue–Sat = No ---------- */
  form.addEventListener('change', e => {
    if (e.target.name === 'Available Tue-Sat'){
      const no = e.target.value === 'No';
      noWhyField.hidden = !no;
      noWhy.required = no;
      if (!no){ noWhy.value = ''; noWhyField.classList.remove('bad'); }
    }
  });

  /* ---------- files ---------- */
  function listFiles(input, target, max){
    target.innerHTML = '';
    [...input.files].slice(0, max || 10).forEach(f => {
      const c = document.createElement('span');
      c.className = 'file-chip';
      c.textContent = f.name + ' · ' + (f.size / 1048576).toFixed(1) + ' MB';
      target.appendChild(c);
    });
  }
  photos.addEventListener('change', () => { listFiles(photos, photosList, 4); photosField.classList.remove('bad'); linkField.classList.remove('bad'); });
  resume.addEventListener('change', () => listFiles(resume, resumeList, 1));

  /* drag + drop */
  [[photosDrop, photos],[resumeDrop, resume]].forEach(([drop, input]) => {
    ['dragenter','dragover'].forEach(ev => drop.addEventListener(ev, e => { e.preventDefault(); drop.classList.add('hot'); }));
    ['dragleave','drop'].forEach(ev => drop.addEventListener(ev, e => { e.preventDefault(); drop.classList.remove('hot'); }));
    drop.addEventListener('drop', e => {
      if (!e.dataTransfer.files.length) return;
      input.files = e.dataTransfer.files;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---------- submit ---------- */
  /* Continue and Enter never rely on native form submission — sandboxed iframes
     (previews, some CMS editors) block that silently and nothing happens. */
  function advance(){
    if (i < last){ go(1); return; }
    if (validate(i)){ go(1); return; }
    send();
  }
  nextBtn.addEventListener('click', advance);
  form.addEventListener('submit', e => { e.preventDefault(); advance(); });
  form.addEventListener('keydown', e => {
    if (e.key !== 'Enter') return;
    if (e.target.tagName === 'TEXTAREA' || e.target.type === 'file') return;
    e.preventDefault();
    advance();
  });

  async function send(){
    nextBtn.disabled = true;
    nextBtn.textContent = 'Sending…';
    footNote.style.color = '';

    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok){
        let detail = 'Formspree returned ' + res.status;
        try {
          const j = await res.json();
          if (j.errors && j.errors.length) detail = j.errors.map(x => x.message).join('. ');
          else if (j.error) detail = j.error;
        } catch(_){}
        throw new Error(detail);
      }

      /* light the candle, then reveal */
      i = steps.length; parts.forEach(p => p.classList.add('on'));
      fill.style.width = '100%';
      rows.forEach(r => { r.classList.add('done'); r.classList.remove('now'); });
      barStep.textContent = 'Sent'; barCount.textContent = 'Thank you';
      setTimeout(() => { form.style.display = 'none'; done.classList.add('on'); }, 550);
    } catch (err) {
      nextBtn.disabled = false;
      nextBtn.textContent = 'Try again';
      footNote.style.color = 'var(--cherry)';
      /* TypeError from fetch = the request never left the page: CSP sandbox,
         offline, or blocked cross-origin. Anything else = Formspree answered back. */
      const blocked = err instanceof TypeError;
      footNote.textContent = blocked
        ? 'Couldn\u2019t reach Formspree — this page blocks outside requests. Test on a real URL.'
        : err.message + ' — or email annie@annielovescakes.com.au.';
      console.error('[ALC form] send failed:', err);
    }
  }

  paint();

  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();